export const featuredReviewsQuery = `
*[_type=="review" && approved==true && featured==true]
| order(rating desc, _createdAt desc)[0...12]{
  _id,
  firstName,
  lastName,
  location,
  rating,
  reviewText,
  ownerReply,
  respondedAt,
  _createdAt,
  "date": string(_createdAt)[0...10]
}
`;
